import React, { useEffect, useState, useRef } from "react";
import { useSwipeable } from "react-swipeable";
import { BsFacebook, BsDiscord } from 'react-icons/bs';
import { RiInstagramFill } from 'react-icons/ri';
import "./resources.css";

import ornament from './resources-images/MYCSERESOURCES.jpg';
import ornament2 from './resources-images/allenschoolpeeradvising.jpg';
import ornament3 from './resources-images/odegard.jpg';
import ornament4 from './resources-images/academiccoaching.jpg';
import ornament5 from './resources-images/CLUE.png';
import ornament12 from './resources-images/codingitforward.png'; // Assuming you have these images
import ornament13 from './resources-images/deShaw.webp';
import ornament14 from './resources-images/Befellowship.jpg';
import ornament15 from './resources-images/developeforgood.jpg';
import ornament16 from './resources-images/rewritingcode.jpg';
import ornament17 from './resources-images/csinternships.jpg';
import ornament18 from './resources-images/counselingcenter.jpg';
import ornament19 from './resources-images/mentalhealth.jpg';
import ornament20 from './resources-images/livewell.jpg';
import ornament21 from './resources-images/huskyhealthcenter.jpg';
import ornament22 from './resources-images/wic.jpg';

export const CarouselItem = ({ children, width, url }) => {
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className="carousel-item"
      style={{ width, boxShadow: isHovered ? "0 0 8px rgba(0, 0, 0, 0.3)" : "none" }}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
    >
      <a href={url} target="_blank" rel="noopener noreferrer" className="grid-link">
        <p className="words_header">{children}</p>
      </a>
    </div>
  );
};

const Resources = ({ carouselItems }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [paused, setPaused] = useState(false);
  const ref = useRef(null);

  const updateIndex = (newIndex) => {
    const itemCount = React.Children.count(carouselItems);
    setActiveIndex((newIndex + itemCount) % itemCount);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      if (!paused) {
        updateIndex(activeIndex + 1);
      }
    }, 3000);

    return () => clearInterval(interval);
  }, [activeIndex, paused]);

  const handlers = useSwipeable({
    onSwipedLeft: () => updateIndex(activeIndex + 1),
    onSwipedRight: () => updateIndex(activeIndex - 1)
  });

  return (
    <div className="resources_container">
      <h3 className="resources_title rounded title-padding">
        <b>Resources</b>
      </h3>

      <div className="quotes-container">
      <h2
            className="header"
            style={{
              marginTop: "1rem",
              // color: "#001f3f",      // dark blue
              textAlign: "center",   // centered
              fontWeight: "bold",    // bold
              fontSize: "2rem"     // bigger
            }}
          >
            WiC Voices: advice from current WiC members!
          </h2>
            <h3 className="subheader" style={{ marginTop: "1rem" }}>Why did you choose CS?</h3>
          <div className="quote-card">
            <p className="quote-text">"UW CS has a lot of ml/data science classes, along with a data science specialization, so I felt like this was the best place for me to learn and grow and get what I wanted out of college :)"</p>
            <p className="quote-author">— On why they chose CS</p>
          </div>
          <div className="quote-card">
            <p className="quote-text">"Seeing the opportunities it opened up and all the good it could do in the world."</p>
            <p className="quote-author">— On why they chose CS</p>
          </div>
          <div className="quote-card">
            <p className="quote-text">"Joining robotics!"</p>
            <p className="quote-author">— On why they chose CS</p>
          </div>
          <h3 className="subheader">Any Advice for incoming CS students?</h3>
          <div className="quote-card">
            <p className="quote-text">"Have fun! CS is hard, but it's hard for everyone. So you have a default community of people with the same struggles."</p>
            <p className="quote-author">— Advice for incoming CS students</p>
          </div>
          <div className="quote-card">
            <p className="quote-text">"Find people and make study groups! It's a great way to make friends and learn content."</p>
            <p className="quote-author">— Advice for incoming CS students</p>
          </div>
          <h3 className="subheader">What have you learned about being a woman in computing?</h3>
          <div className="quote-card">
            <p className="quote-text">"You definitely start to notice the gender gap once you get to upper level classes."</p>
            <p className="quote-author">— On being a woman in computing</p>
          </div>
          <h3 className="subheader">What helped you land your first job or internship in tech?</h3>
          <div className="quote-card">
            <p className="quote-text">"Attending GHC"</p>
            <p className="quote-author">— On what helped land first job or internship</p>
          </div>
          <div className="quote-card">
            <p className="quote-text">"Joining the organization Rewriting the Code and applying early!"</p>
            <p className="quote-author">— On what helped land first job or internship</p>
          </div>
    </div>


    <h2
            className="header"
            style={{
              marginTop: "1rem",
              // color: "#001f3f",      // dark blue
              textAlign: "center",   // centered
              fontWeight: "bold",    // bold
              fontSize: "2rem"     // bigger
            }}
          >
            Academic Resources
          </h2>
      <div className="grid-container">
        {[{
          img: ornament, url: "https://www.cs.washington.edu/content/mycse-undergrad-resources",
          title: "MyCSE Undergrad Resources",
          desc: "Allen School list of resources covering academic and career related resources. Highly recommend the Transitioning into the 300s and 400s Guides!"
        }, {
          img: ornament2, url: "https://www.cs.washington.edu/academics/ugrad/peeradvising",
          title: "Allen School Peer Advising",
          desc: "Peer Advisers can talk about Allen School admissions, personal statement feedback, course planning, internship prep, connecting with research, and general tips for being a successful student."
        }, {
          img: ornament3, url: "https://depts.washington.edu/owrcweb/wordpress/",
          title: "Odegaard Writing & Research Center",
          desc: "Supports the long-term development of writers and researchers across UW—undergraduate and graduate students, faculty, and staff."
        }, {
          img: ornament4, url: "https://academicsupport.uw.edu/academic-success-coach/",
          title: "Academic Support Coaching",
          desc: "Through one-on-one appointments, work with a coach to get from where you are now academically to where you want to be."
        }, {
          img: ornament5, url: "https://academicsupport.uw.edu/clue/",
          title: "CLUE",
          desc: "CLUE tutoring is more than a resource you can access when you're struggling; it's a welcoming, inclusive space for students to connect."
        }].map((resource, index) => (
          <a key={index} href={resource.url} target="_blank" rel="noopener noreferrer" className="grid-link">
            <div className="grid-item">
              <center>
                <img src={resource.img} alt={resource.title} className="tab" />
                <b><p className="words_title">{resource.title}</p></b>
              </center>
              <p className="words">{resource.desc}</p>
            </div>
          </a>
        ))}
      </div>

      <h2
            className="header"
            style={{
              marginTop: "1rem",
              // color: "#001f3f",      // dark blue
              textAlign: "center",   // centered
              fontWeight: "bold",    // bold
              fontSize: "2rem"     // bigger
            }}
          >
            Career Resources
          </h2>

      <div className="grid-container">
        <a href="https://www.codingitforward.com" target="_blank" rel="noopener noreferrer" className="grid-link">
          <div className="grid-item">
            <center><img src={ornament12} alt="cif" className="tab" /><b><p className="words_title">Coding it Forward Fellowship</p></b></center>
            <p className="words">A nonprofit for early-career technologists creating new pathways into public interest technology.</p>
          </div></a>

        <a href="https://fellowships.deshaw.com" target="_blank" rel="noopener noreferrer" className="grid-link">
          <div className="grid-item">
            <center><img src={ornament13} alt="De Shaw" className="tab" /><b><p className="words_title">DE Shaw Fellowship</p></b></center>
            <p className="words">Three day fellowship in DE Shaw offices in New York for second-year students interested in the intersection of tech and finance.</p>
          </div></a>

        <a href="https://www.bvp.com/bessemer-fellows" target="_blank" rel="noopener noreferrer" className="grid-link">
          <div className="grid-item">
            <center><img src={ornament14} alt="Bessemer Fellowship" className="tab" /><b><p className="words_title">Bessemer Fellowship</p></b></center>
            <p className="words">Intern with one of Bessemer's portfolio investment companies, targeted at underrepresented third-year students.</p>
          </div></a>

        <a href="https://www.developforgood.org" target="_blank" rel="noopener noreferrer" className="grid-link">
          <div className="grid-item">
            <center><img src={ornament15} alt="Develop for Good" className="tab" /><b><p className="words_title">Develop for Good</p></b></center>
            <p className="words">Join hundreds of product, engineering, and design students who have volunteered with leading nonprofits to gain experience and address the world's biggest problems.</p>
          </div></a>

        <a href="https://rewritingthecode.org" target="_blank" rel="noopener noreferrer" className="grid-link">
          <div className="grid-item">
            <center><img src={ornament16} alt="Rewriting" className="tab" /><b><p className="words_title">Rewriting the Code</p></b></center>
            <p className="words">The largest peer-to-peer network of women in tech, providing support, mentorship, and education that helps pave the way for sustainable careers, professional advancement, and equal opportunities.</p>
          </div></a>

        <a href="https://github.com/SimplifyJobs/Summer2024-Internships" target="_blank" rel="noopener noreferrer" className="grid-link">
          <div className="grid-item">
            <center><img src={ornament17} alt="Internships" className="tab" /><b><p className="words_title">Summer 2025 Internships</p></b></center>
            <p className="words">GitHub repo with software engineering and other related positions throughout the world.</p>
          </div></a>
      </div>

      <h2
            className="header"
            style={{
              marginTop: "1rem",
              // color: "#001f3f",      // dark blue
              textAlign: "center",   // centered
              fontWeight: "bold",    // bold
              fontSize: "2rem"     // bigger
            }}
          >
            Wellbeing & Mental Health Resources
          </h2>
       <div className="grid-container">
      <a href="link here" target="_blank" rel="noopener noreferrer" className="grid-link">
        <div className="grid-item">
          <center><img src={ornament22} alt="wic" className="tab" /><b><p className="words_title">Our Stories</p></b></center>
            <p className="words"> Sometimes it gets tough. It is important to see that everyone struggles, not just you. Here you can read more about wic members tough experiences in CS.</p>
      </div></a>

      <a href="https://wellbeing.uw.edu/unit/counseling-center/" target="_blank" rel="noopener noreferrer" className="grid-link">
        <div className="grid-item">
          <center><img src={ornament18} alt="UW counseling ctr" className="tab" /><b><p className="words_title">UW Counseling Center</p></b></center>
            <p className="words"> The UW Counseling Center is here to support you during your time at UW so that you have a positive, fulfilling experience.</p>
      </div></a>

      <a href="https://wellbeing.uw.edu/mental-health/mental-health-resources/" target="_blank" rel="noopener noreferrer" className="grid-link">
        <div className="grid-item">
          <center><img src={ornament19} alt="mental health" className="tab" /><b><p className="words_title">UW Mental Health Resources</p></b></center>
            <p className="words">A toolbox of mental health resources found on campus.</p>
      </div></a>

      <a href="https://wellbeing.uw.edu/unit/livewell/" target="_blank" rel="noopener noreferrer" className="grid-link">
        <div className="grid-item">
          <center><img src={ornament20} alt="Live Well" className="tab" /><b><p className="words_title">Livewell</p></b></center>
            <p className="words">LiveWell supports the personal and social development of students by providing evidence-based information and education to help enhance life skills.</p>
      </div></a>

      <a href="https://wellbeing.uw.edu/unit/hall-health/" target="_blank" rel="noopener noreferrer" className="grid-link">
        <div className="grid-item">
          <center><img src={ornament21} alt="Hall Health" className="tab" /><b><p className="words_title">Hall Health</p></b></center>
            <p className="words">Provides exceptional medical and mental health care to our diverse student body as well as established non-student patients. </p>
      </div></a>
      </div>

      <div className='actions' ref={ref}>
      <div className='action-description'>
          <p ><strong>Not a  WiC member?</strong></p>
          <p>Join <a href='http://tinyurl.com/wic-membership-form' target='_blank' class='footerLink'>here</a> and sign up for 
          our <a href='https://mailman.cs.washington.edu/mailman/listinfo/wic' target='_blank'  class='footerLink'>mailing list</a> to 
          get updates on events and opportunities! Follow us on our Facebook and Instagram page! Join our Discord server!</p>
        </div>
         <br></br>
        <div className='socials'>
          <a id='insta' href='https://www.instagram.com/uw.wic/' target='_blank' rel="noreferrer"><RiInstagramFill/></a>
          <a id='fbook' href='https://www.facebook.com/uwwic' target='_blank' rel="noreferrer"><BsFacebook/></a>
            <a id='discord' href='https://discord.gg/Zp4GVB7ddq' target='_blank' rel="noreferrer"><BsDiscord/></a>
        </div>
        <div className='wicEmail'>
          <a href="mailto:wic-officers@cs.washington.edu" class='footerLink'>wic-officers@cs.washington.edu</a>
        </div>
      </div>
    </div>
  );
};

export default Resources;
